// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import cropperStyle from 'cropperjs/dist/cropper.css';
import {Cropper as BaseCrop} from 'react-cropper';

import styled, {css} from 'styled-components';

import {Button} from '../Button';
import {mixins} from '../styles';

const LeftButton = styled(Button)`
  margin-right: ${({theme}) => theme.spacing.s2};
`;

const Info = styled.span`
  ${mixins.f2}
  color: ${({theme}) => theme.branding.content.secondary};
`;

const CroppedInfo = styled(Info)`
  color: ${({theme}) => theme.palette.green500};
`;

const Crop = styled(BaseCrop)`
  ${cropperStyle};
  position: relative;
  overflow: hidden;
  width: 400px;
  height: 400px;
  ${({theme}) => css`
    margin-bottom: ${theme.spacing.s2};

    .cropper-crop-box {
      border: 3px solid ${theme.branding.colors.accentA};
    }
    .cropper-view-box {
      outline: none;
    }
    .cropper-point {
      background-color: ${theme.branding.colors.accentA};
    }
    .cropper-line {
      .line-n,
      .line-e,
      .line-s,
      .line-w {
        opacity: 0;
      }
    }
  `}
`;

export {LeftButton, Crop, Info, CroppedInfo};
